import { IMilestoneTemplate } from "@/interfaces";

export const findTargetParentMilestoneRecursive = (
  milestones: IMilestoneTemplate[],
  target: IMilestoneTemplate
): IMilestoneTemplate | undefined => {
  let foundParent = milestones.find(({ id }) => id === target.id);

  if (foundParent) return foundParent;

  for (const milestone of milestones) {
    if (!milestone.childMilestones?.length) continue;

    foundParent = findTargetParentMilestoneRecursive(
      milestone.childMilestones,
      target
    );

    if (foundParent) break;
  }

  return foundParent;
};
